import React from "react";
import { MapTo } from "@adobe/aem-react-editable-components";
import { SpacerWrapper } from "./Spacer.styles";
import { SpacerProps } from "./Spacer.types";

export default function Spacer(props: SpacerProps) {
	return (
		<>
			{props.mobile && (
				<SpacerWrapper
					style={{ background: props.background || "transparent" }}
				>
					<div
						className="spacer__mobile"
						style={{ height: `${props.mobile}px` }}
					></div>
					<div
						className="spacer__tablet"
						style={{ height: `${props.tablet}px` }}
					></div>
					<div
						className="spacer__desktop"
						style={{ height: `${props.desktop}px` }}
					></div>
				</SpacerWrapper>
			)}
		</>
	);
}

export const SpacerEditConfig = {
	emptyLabel: "Espaçamento",

	isEmpty: function (props: SpacerProps) {
		return !props || !props.mobile;
	},
};

MapTo<SpacerProps>("alelo/components/content/v1/spacer")(
	Spacer,
	SpacerEditConfig
);
